export const model = {
    fields: {
        name: {
            isRequired: true,
            errors: []
        }
    }
}